/**
 * HDP API routing during Flask → Django migration.
 * Production still defaults to Flask until feature flags are enabled.
 */

const flaskBase = process.env.REACT_APP_API_URL || '/api';
const djangoBase = process.env.REACT_APP_DJANGO_API_BASE_URL || '/api/django';

export const API_CONFIG = {
  flaskBase,
  djangoBase,
  useDjangoHdp: process.env.REACT_APP_USE_DJANGO_HDP === 'true',
  modules: {
    cases: process.env.REACT_APP_USE_DJANGO_CASES === 'true',
    evidence: process.env.REACT_APP_USE_DJANGO_EVIDENCE === 'true',
    personas: process.env.REACT_APP_USE_DJANGO_PERSONAS === 'true',
    iocs: process.env.REACT_APP_USE_DJANGO_IOCS === 'true',
    reports: process.env.REACT_APP_USE_DJANGO_REPORTS === 'true',
    actors: process.env.REACT_APP_USE_DJANGO_ACTORS === 'true',
  },
};

export function hdpApiBase(module) {
  if (API_CONFIG.useDjangoHdp || API_CONFIG.modules[module]) {
    return djangoBase;
  }
  return flaskBase;
}

export default API_CONFIG;
